export const BASE_API_URL = 'https://api.currentsapi.services/v1';
export const GET_NEWS_FOR_MAIN_ENDPOINT =
  '/latest-news?category=technology&page_size=4&apiKey=';
export const GET_ALL_NEWS_ENDPOINT = '/latest-news?category=technology&apiKey=';
